import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-delete-payment-processors',
  templateUrl: './delete-payment-processors.component.html',
  styleUrls: ['./delete-payment-processors.component.scss']
})
export class DeletePaymentProcessorsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
